export default class ApiUrl {
  //Production
  public static baseUrl: string = "https://crm.atmoondps.com";
  // public static baseUrl: string = "http://localhost:8080";
}
